module.exports = __webpack_public_path__ + "img/63.314a2d0f.png";